import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigStateService } from "../config/config-state.service";

@Injectable()
export class WafRuleInterceptor implements HttpInterceptor {
  constructor(private config: ConfigStateService) {}

  routesWithTags = ["/comment", "/comment/commentWithAnswers"];

  sanitiseWafRuleExceptions(value, sanataizeTagsWithBackSlash) {
    // needs to be done recursively, as different payloads store user-input at different object levels
    // matching <>, "", '', and `` containing unbroken special characters
    const openTagRegex = /</gi;
    const tagRegex = /<([^a-z1-9 ]*)>/gi;
    const doubleQuoteRegex = /"([^a-z1-9 ]*)"/gi;
    const singleQuoteRegex = /'([^a-z1-9 ]*)'/gi;
    const backtickRegex = /`([^a-z1-9 ]*)`/gi;
    // const doubleDashRegex = /--/gi

    if (typeof value === "string") {
      if (sanataizeTagsWithBackSlash) {
        value = value.replace(openTagRegex, `\\<`);
      } else {
        value = value.replace(tagRegex, "< $1 >");
      }
      value = value.replace(doubleQuoteRegex, "\" $1 \"");
      value = value.replace(singleQuoteRegex, "\' $1 \'");
      value = value.replace(backtickRegex, "\` $1 \`");
      // value = value.replace(doubleDashRegex,"- - ")
      // ...expand regex if more examples of sanitation required
      return value;
    }

    if (value && typeof value === "object") {
      if (Array.isArray(value)) {
        return value.map(v => this.sanitiseWafRuleExceptions(v, sanataizeTagsWithBackSlash));
      }
      for (const key in value) {
        value[key] = this.sanitiseWafRuleExceptions(value[key], sanataizeTagsWithBackSlash);
      }
    }
    return value;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.method.toUpperCase() === "POST" ||
      req.method.toUpperCase() === "PUT"
    ) {
      const sanataizeTagsWithBackSlash = this.routesWithTags.some(route => req.url.endsWith(route));

      const isFormData = req.body instanceof FormData;
      if (
        req.body &&
        !isFormData &&
        req.headers.get("Accept") === "application/json" &&
        !req.body["encoded"]
      ) {
        const sanitisedReqBody = this.sanitiseWafRuleExceptions(
          req.body,
          sanataizeTagsWithBackSlash
        );
        const sanitisedReq = req.clone({
          body: { ...req.body, ...sanitisedReqBody }
        });
        return next.handle(sanitisedReq);
      }
    }
    return next.handle(req);
  }
}
